//derived these colors from https://www.weather.gov/help-map
import { Feature, FeatureCollection } from "geojson";

export const EVENT_TYPES = {
    "Tsunami Warning": {
        color: "#FD6347",
        critical: false,
    },
    "Tornado Warning": {
        color: "#FF0000",
        critical: true,
    },
    "Extreme Wind Warning": {
        color: "#FF8C00",
        critical: true,
    },
    "Severe Thunderstorm Warning": {
        color: "#FFA500",
        critical: true,
    },
    "Flash Flood Warning": {
        color: "#8B0000",
        critical: true,
    },
    "Flash Flood Statement": {
        color: "#8B0000",
        critical: false,
    },
    "Severe Weather Statement": {
        color: "#00FFFF",
        critical: false,
    },
    "Shelter In Place Warning": {
        color: "#FA8072",
        critical: false,
    },
    "Evacuation Immediate": {
        color: "#7FFF00",
        critical: false,
    },
    "Civil Danger Warning": {
        color: "#FFB6C1",
        critical: false,
    },
    "Nuclear Power Plant Warning": {
        color: "#4B0082",
        critical: false,
    },
    "Radiological Hazard Warning": {
        color: "#4B0082",
        critical: false,
    },
    "Hazardous Materials Warning": {
        color: "#4B0082",
        critical: false,
    },
    "Fire Warning": {
        color: "#A0522D",
        critical: false,
    },
    "Civil Emergency Message": {
        color: "#FFB6C1",
        critical: false,
    },
    "Law Enforcement Warning": {
        color: "#C0C0C0",
        critical: false,
    },
    "Storm Surge Warning": {
        color: "#B524F7",
        critical: false,
    },
    "Hurricane Force Wind Warning": {
        color: "#CD5C5C",
        critical: false,
    },
    "Hurricane Warning": {
        color: "#DC143C",
        critical: false,
    },
    "Typhoon Warning": {
        color: "#DC143C",
        critical: false,
    },
    "Special Marine Warning": {
        color: "#FFA500",
        critical: false,
    },
    "Blizzard Warning": {
        color: "#FF4500",
        critical: false,
    },
    "Snow Squall Warning": {
        color: "#C71585",
        critical: true,
    },
    "Ice Storm Warning": {
        color: "#8B008B",
        critical: false,
    },
    "Heavy Freezing Spray Warning": {
        color: "#00BFFF",
        critical: false,
    },
    "Winter Storm Warning": {
        color: "#FF69B4",
        critical: false,
    },
    "Lake Effect Snow Warning": {
        color: "#008B8B",
        critical: false,
    },
    "Dust Storm Warning": {
        color: "#FFE4C4",
        critical: true,
    },
    "Blowing Dust Warning": {
        color: "#FFE4C4",
        critical: false,
    },
    "High Wind Warning": {
        color: "#DAA520",
        critical: false,
    },
    "Tropical Storm Warning": {
        color: "#B22222",
        critical: false,
    },
    "Storm Warning": {
        color: "#9400D3",
        critical: false,
    },
    "Tsunami Advisory": {
        color: "#D2691E",
        critical: false,
    },
    "Tsunami Watch": {
        color: "#FF00FF",
        critical: false,
    },
    "Avalanche Warning": {
        color: "#1E90FF",
        critical: false,
    },
    "Earthquake Warning": {
        color: "#8B4513",
        critical: false,
    },
    "Volcano Warning": {
        color: "#2F4F4F",
        critical: false,
    },
    "Ashfall Warning": {
        color: "#A9A9A9",
        critical: false,
    },
    "Flood Warning": {
        color: "#00FF00",
        critical: false,
    },
    "Coastal Flood Warning": {
        color: "#228B22",
        critical: false,
    },
    "Lakeshore Flood Warning": {
        color: "#228B22",
        critical: false,
    },
    "Ashfall Advisory": {
        color: "#696969",
        critical: false,
    },
    "High Surf Warning": {
        color: "#228B22",
        critical: false,
    },
    "Extreme Heat Warning": {
        color: "#C71585",
        critical: false,
    },
    "Tornado Watch": {
        color: "#FFFF00",
        critical: false,
    },
    "Severe Thunderstorm Watch": {
        color: "#DB7093",
        critical: false,
    },
    "Flash Flood Watch": {
        color: "#2E8B57",
        critical: false,
    },
    "Gale Warning": {
        color: "#DDA0DD",
        critical: false,
    },
    "Flood Statement": {
        color: "#00FF00",
        critical: false,
    },
    "Extreme Cold Warning": {
        color: "#0000FF",
        critical: false,
    },
    "Freeze Warning": {
        color: "#483D8B",
        critical: false,
    },
    "Red Flag Warning": {
        color: "#FF1493",
        critical: false,
    },
    "Storm Surge Watch": {
        color: "#DB7FF7",
        critical: false,
    },
    "Hurricane Watch": {
        color: "#FF00FF",
        critical: false,
    },
    "Hurricane Force Wind Watch": {
        color: "#9932CC",
        critical: false,
    },
    "Typhoon Watch": {
        color: "#FF00FF",
        critical: false,
    },
    "Tropical Storm Watch": {
        color: "#F08080",
        critical: false,
    },
    "Storm Watch": {
        color: "#FFE4B5",
        critical: false,
    },
    "Tropical Cyclone Local Statement": {
        color: "#FFE4B5",
        critical: false,
    },
    "Winter Weather Advisory": {
        color: "#7B68EE",
        critical: false,
    },
    "Avalanche Advisory": {
        color: "#CD853F",
        critical: false,
    },
    "Cold Weather Advisory": {
        color: "#AFEEEE",
        critical: false,
    },
    "Heat Advisory": {
        color: "#FF7F50",
        critical: false,
    },
    "Flood Advisory": {
        color: "#00FF7F",
        critical: false,
    },
    "Coastal Flood Advisory": {
        color: "#7CFC00",
        critical: false,
    },
    "Lakeshore Flood Advisory": {
        color: "#7CFC00",
        critical: false,
    },
    "High Surf Advisory": {
        color: "#BA55D3",
        critical: false,
    },
    "Dense Fog Advisory": {
        color: "#708090",
        critical: false,
    },
    "Dense Smoke Advisory": {
        color: "#F0E68C",
        critical: false,
    },
    "Small Craft Advisory": {
        color: "#D8BFD8",
        critical: false,
    },
    "Brisk Wind Advisory": {
        color: "#D8BFD8",
        critical: false,
    },
    "Hazardous Seas Warning": {
        color: "#D8BFD8",
        critical: false,
    },
    "Dust Advisory": {
        color: "#BDB76B",
        critical: false,
    },
    "Blowing Dust Advisory": {
        color: "#BDB76B",
        critical: false,
    },
    "Lake Wind Advisory": {
        color: "#D2B48C",
        critical: false,
    },
    "Wind Advisory": {
        color: "#D2B48C",
        critical: false,
    },
    "Frost Advisory": {
        color: "#6495ED",
        critical: false,
    },
    "Freezing Fog Advisory": {
        color: "#008080",
        critical: false,
    },
    "Freezing Spray Advisory": {
        color: "#00BFFF",
        critical: false,
    },
    "Low Water Advisory": {
        color: "#A52A2A",
        critical: false,
    },
    "Local Area Emergency": {
        color: "#C0C0C0",
        critical: false,
    },
    "Winter Storm Watch": {
        color: "#4682B4",
        critical: false,
    },
    "Rip Current Statement": {
        color: "#40E0D0",
        critical: false,
    },
    "Beach Hazards Statement": {
        color: "#40E0D0",
        critical: false,
    },
    "Gale Watch": {
        color: "#FFC0CB",
        critical: false,
    },
    "Avalanche Watch": {
        color: "#F4A460",
        critical: false,
    },
    "Hazardous Seas Watch": {
        color: "#483D8B",
        critical: false,
    },
    "Heavy Freezing Spray Watch": {
        color: "#BC8F8F",
        critical: false,
    },
    "Flood Watch": {
        color: "#2E8B57",
        critical: false,
    },
    "Coastal Flood Watch": {
        color: "#66CDAA",
        critical: false,
    },
    "Lakeshore Flood Watch": {
        color: "#66CDAA",
        critical: false,
    },
    "High Wind Watch": {
        color: "#B8860B",
        critical: false,
    },
    "Extreme Heat Watch": {
        color: "#800000",
        critical: false,
    },
    "Extreme Cold Watch": {
        color: "#5F9EA0",
        critical: false,
    },
    "Freeze Watch": {
        color: "#00FFFF",
        critical: false,
    },
    "Fire Weather Watch": {
        color: "#FFDEAD",
        critical: false,
    },
    "Extreme Fire Danger": {
        color: "#E9967A",
        critical: false,
    },
    "911 Telephone Outage": {
        color: "#C0C0C0",
        critical: false,
    },
    "Coastal Flood Statement": {
        color: "#6B8E23",
        critical: false,
    },
    "Lakeshore Flood Statement": {
        color: "#6B8E23",
        critical: false,
    },
    "Special Weather Statement": {
        color: "#FFE4B5",
        critical: false,
    },
    "Marine Weather Statement": {
        color: "#FFDAB9",
        critical: false,
    },
    "Air Quality Alert": {
        color: "#808080",
        critical: false,
    },
    "Air Stagnation Advisory": {
        color: "#808080",
        critical: false,
    },
    "Hazardous Weather Outlook": {
        color: "#EEE8AA",
        critical: false,
    },
    "Hydrologic Outlook": {
        color: "#90EE90",
        critical: false,
    },
    "Short Term Forecast": {
        color: "#98FB98",
        critical: false,
    },
    "Administrative Message": {
        color: "#C0C0C0",
        critical: false,
    },
    "Test Message": { // this is not in the list of API return types, but empirically it is returned.
        color: "#F0FFFF",
        critical: false,
    },
    "Test": {
        color: "#F0FFFF",
        critical: false,
    },
    "Child Abduction Emergency": {
        color: "#FFFFFF",
        critical: false,
    },
    "Blue Alert": {
        color: "#FFFFFF",
        critical: false,
    },
};

export const EXCLUDED_EVENT_TYPES = new Set<string>( [
    "911 Telephone Outage",
    "Administrative Message",
    "Air Quality Alert",
    "Air Stagnation Advisory",
    "Beach Hazards Statement",
    "Blue Alert",
    "Brisk Wind Advisory",
    "Child Abduction Emergency",
    "Civil Danger Warning",
    "Civil Emergency Message",
    "Evacuation Immediate",
    "Fire Warning",
    "Fire Weather Watch",
    "Flash Flood Statement",
    "Flood Statement",
    "Freezing Spray Advisory",
    "Frost Advisory",
    "Gale Warning",
    "Gale Watch",
    "Hazardous Materials Warning",
    "Hazardous Seas Warning",
    "Hazardous Seas Watch",
    "Hazardous Weather Outlook",
    "Heavy Freezing Spray Warning",
    "Heavy Freezing Spray Watch",
    "Heavy Freezing Spray Advisory",
    "High Surf Advisory",
    "High Surf Warning",
    "Hydrologic Outlook",
    "Lake Wind Advisory",
    "Lakeshore Flood Advisory",
    "Lakeshore Flood Statement",
    "Lakeshore Flood Warning",
    "Lakeshore Flood Watch",
    "Law Enforcement Warning",
    "Local Area Emergency",
    "Low Water Advisory",
    "Marine Weather Statement",
    "Nuclear Power Plant Warning",
    "Radiological Hazard Warning",
    "Rip Current Statement",
    "Severe Weather Statement",
    "Shelter In Place Warning",
    "Short Term Forecast",
    "Small Craft Advisory",
    "Special Marine Warning",
    "Storm Warning",
    "Storm Watch",
    "Test",
    "Test Message",
    "Tropical Cyclone Local Statement",
    "Typhoon Warning",
    "Typhoon Watch",
] );

export const FALLBACK_ALERT = {
    color: "#ff0000",
    critical: false,
};

// fetchWeatherAlerts can trigger a large number of parallel fetches due to the NWS data model:
// a single alert may reference multiple zone IDs, each requiring a separate geometry request.
// Unbounded parallelism can exceed browser request limits and cause net::ERR_INSUFFICIENT_RESOURCES.
// To mitigate this, we cap the number of in-flight requests. This limit was empirically determined
// under high-alert conditions where unrestricted concurrency caused failures.
const CONCURRENCY_LIMIT = 50;

export async function fetchWeatherAlerts( signal: AbortSignal, onProgress?: ( fractionLoaded: number ) => void ): Promise<FeatureCollection>
{
    const res = await fetch( "https://api.weather.gov/alerts/active", { signal } );
    const data = await res.json();

    if ( data.features === undefined )
    {
        return { type: "FeatureCollection", features: [] };
    }

    const alertsWithGeometry: Array<Feature> = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const alertsNeedingZoneFetch: Array<{ alert: any, zones: Array<string> }> = [];

    for ( const alert of data.features )
    {
        const eventType = alert.properties?.event as keyof typeof EVENT_TYPES;
        if ( EXCLUDED_EVENT_TYPES.has( eventType ) ) continue;
        const alertTypeInfo = EVENT_TYPES[eventType] ?? FALLBACK_ALERT;
        if ( alertTypeInfo === undefined ) continue;

        alert.properties.color = alertTypeInfo.color;
        alert.properties.isCritical = alertTypeInfo.critical;

        if ( alert.geometry !== null )
        {
            alertsWithGeometry.push( alert );
        }
        else if ( alert.properties.affectedZones.length > 0 )
        {
            alertsNeedingZoneFetch.push( { alert, zones: alert.properties.affectedZones } );
        }
    }

    const allZoneUrls = alertsNeedingZoneFetch.flatMap( ( { zones } ) => zones );

    let completed = 0;
    const total = allZoneUrls.length;

    // Create fetch promises that update progress as they resolve
    const zonePromises = allZoneUrls.map( ( url ) => async () =>
    {
        try
        {
            const zoneResponse = await fetch( url, { signal } );
            return await zoneResponse.json();
        }
        catch ( err )
        {
            console.warn( "Zone fetch failed for", url, err );
            return null;
        }
        finally
        {
            completed++;
            if ( onProgress )
            {
                requestAnimationFrame( () =>
                {
                    onProgress( completed / total );
                } );
            }
        }
    } );

    const zoneResponses = await runWithConcurrencyLimit(
        zonePromises,
        CONCURRENCY_LIMIT
    );

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const zoneGeometries = new Map<string, any>();

    for ( const zoneData of zoneResponses )
    {
        if ( zoneData?.geometry !== undefined && zoneData?.id !== undefined )
        {
            zoneGeometries.set( zoneData.id, zoneData.geometry );
        }
    }


    for ( const { alert, zones } of alertsNeedingZoneFetch )
    {
        const eventType = alert.properties?.event as keyof typeof EVENT_TYPES;
        const alertTypeInfo = EVENT_TYPES[eventType] ?? FALLBACK_ALERT;
        if ( alertTypeInfo === undefined ) continue;

        for ( const zoneUrl of zones )
        {
            const geometry = zoneGeometries.get( zoneUrl );
            if ( geometry !== undefined )
            {
                alertsWithGeometry.push( {
                    type: "Feature",
                    geometry,
                    properties: {
                        ...alert.properties,
                        color: alertTypeInfo.color,
                        isCritical: alertTypeInfo.critical,
                    },
                } );
            }
        }
    }

    return {
        type: "FeatureCollection",
        features: alertsWithGeometry,
    };
}

async function runWithConcurrencyLimit<T>(
    tasks: Array<() => Promise<T>>,
    limit: number
): Promise<Array<T>>
{
    const results: Array<T> = [];
    let index = 0;

    async function worker()
    {
        while ( index < tasks.length )
        {
            const current = index++;
            results[current] = await tasks[current]();
        }
    }

    const workers = Array.from(
        { length: Math.min( limit, tasks.length ) },
        () => worker()
    );

    await Promise.all( workers );
    return results;
}
